import ProfessionalService from '../services/professional.service';

const professionals = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    searchProfessional(_, crmOrName) {
      return ProfessionalService.searchProfessional(crmOrName);
    },
  },

  getters: {},
};

export default professionals;
